import { gql } from "@apollo/client";
import moment from "moment";

export const GET_NOTES_DATA = gql`
   query GetNotes($notes: getNotes) {
      getNotes(Notes: $notes) {
         notes {
            id
            encounterId
            isDisable
            diarization
            mediaId
            status
            title
            createdAt
            notes
            isRead
            noteObject
            templateId
            isCopiedToEhr
            template {
               title
            }
         }
         totalCount
      }
   }
`;
export const CREATE_NOTES = gql`
   mutation Mutation($createNotes: createNotes) {
      createNotes(createNotes: $createNotes) {
         status {
            code
            message
            success
         }
         notes {
            id
            notes
            templateTitle
            title
         }
         media {
            signUrl
         }
      }
   }
`;

export const CREATE_NOTES_V2 = gql`
   mutation CreateNotesV2($createNotesV2: createNotes) {
      createNotesV2(createNotesV2: $createNotesV2) {
         notes {
            id
         }
         status {
            code
         }
      }
   }
`;

export const CREATE_TEMPLATE = gql`
   mutation UpsertNotesTemplate($notesTemplate: NoteTemplateInput) {
      upsertNotesTemplate(notesTemplate: $notesTemplate) {
         status {
            code
            success
            message
         }
         template {
            id
            title
         }
      }
   }
`;
export const DELETE_CREATE_NOTES = gql`
   mutation Mutation($createNotes: createNotes) {
      createNotes(createNotes: $createNotes) {
         status {
            code
            success
            message
         }
      }
   }
`;

export const GET_SIGNED_URL_V2 = gql`
   query Query($noteId: String, $fileName: String) {
      getCreateNotesSignedUrl(noteId: $noteId, fileName: $fileName) {
         signedUrl
         status {
            code
            message
         }
      }
   }
`;

export const GET_NOTES_TEMPLATES_DATA = gql`
   query GetNotesTemplate($notesTemplate: getNotesTemplate) {
      getNotesTemplate(notesTemplate: $notesTemplate) {
         totalCount
         template {
            id
            providerId
            enterpriseId
            hospitalId
            isDisable
            title
            description
            documentId
            alreadyExists
            isSampleAvailable
            sample
            shortDescription
         }
      }
   }
`;
export const UPDATE_NOTES = gql`
   mutation Mutation($notesTemplate: NoteTemplateInput) {
      upsertNotesTemplate(notesTemplate: $notesTemplate) {
         status {
            code
            success
            message
         }
      }
   }
`;
export const GET_DICTATION_SIGNED_URL = gql`
   query GetSignedURL($thumbnail: Boolean!, $content: ContentInput, $includeDiarization: Boolean) {
      getSignedURL(thumbnail: $thumbnail, content: $content, includeDiarization: $includeDiarization) {
         Diarization
         thumbnailUrl
         url
         Transcription
         dataCount
      }
   }
`;

export const getFormattedStampDateTime = (stampDate) => {
   const date = new Date(stampDate);
   let oneDate = moment(date);
   let dayName = oneDate.format("dddd");
   let diffInDays = Math.round(moment().diff(stampDate, "days", true));
   if (diffInDays === 0) {
      return (dayName = "Today  at " + moment(date).format("hh:mm A"));
   } else if (diffInDays === 1) {
      return (dayName = "Yesterday  at " + moment(date).format("hh:mm A"));
   } else {
      return moment(date).format("MM/DD/YYYY") + " at " + moment(date).format("hh:mm A");
   }
};
